import axios from 'axios'


class APIConfInvioMail {

  getUrlDomain(nome_metodo) {

    let result = "";

    if (location.hostname == "localhost") {
      result = location.protocol + "//emtool.local/";
    }

    if (location.hostname != "localhost") {

      result = "https://companysupport.eu/";

    }

    return result + nome_metodo;

  }

  async setConfInvioMail(impostazioni_invio_mail, user) {


    let formData = new FormData();

    formData.append("username", user);

    for (var key in impostazioni_invio_mail) {
      formData.append(key, impostazioni_invio_mail[key]);
    }

    return axios.post(this.getUrlDomain("TwoRecruitSetConfigInvioMail"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  async setConfInvioMailJM(impostazioni_invio_mail, user, isjm) {


    let formData = new FormData();

    formData.append("username", user);
    formData.append("isjm", isjm);

    for (var key in impostazioni_invio_mail) {
      formData.append(key, impostazioni_invio_mail[key]);
    }

    return axios.post(this.getUrlDomain("TwoRecruitSetConfigInvioMail"), formData, { 'Content-Type': 'multipart/form-data' });

  }






  async getConfInvioMail(user) {


    let formData = new FormData();

    formData.append("username", user);


    return axios.post(this.getUrlDomain("TwoRecruitGetConfigInvioMail"), formData, { 'Content-Type': 'multipart/form-data' });

  }





}

export default new APIConfInvioMail({
  url: "http://emtool.local/public/api/alertduedate/"
})
